import { useState } from "react";

export function usePopup(keys) {
  const [popup, setPopup] = useState(() => {
    const initialValues = keys.reduce((acc, val) => {
      acc[val] = false;
      return acc;
    }, {});

    return initialValues;
  });

  const openPopup = (type) => {
    setPopup((prev) => ({ ...prev, [type]: true }));
  };

  const closePopup = (type) => {
    return () => setPopup((prev) => ({ ...prev, [type]: false }));
  };

  return { popup, openPopup, closePopup };
}
